import pinAnim from "../images/pinAnim.png";
import MainFrame from "../components/MainFrame.jsx";
import useTheMap from "./useTheMap.js";
import PositionScreen from "./components/PositionScreen.jsx";
import Title from "./components/Title.jsx";
import InfoBox from "./components/InfoBox.jsx";
import "../css/main.css";
import GenericModal from "../components/GenericModal.jsx";
import MenuBar from "./components/MenuBar.jsx";
import NextTerritory from "./components/NextTerritory.jsx";
import EventsList from "./components/EventsList.jsx";

export default function TheMap(props) {
  const {
    open,
    open2,
    closeMsg,
    closeMsg2,
    theMapBox,
    mapElement,
    dim,
    openBox2,
    board,
    beginRaster,
    continueRaster,
    finishRaster,
    pinAnimStep,
    startPinAnim,
    confirmPosition,
    resetPosition,
    title,
    sectionId,
    leyendRef,
    address,
    terId,
    buttonsList,
    getFeat,
    points_layer,
    handleClickAddr,
    focusPoint,
    updateCheck,
    closeGPS,
    goTo,
    focusLayer,
    openWindow,
    buttonsMenu,
    msgType,
    scrollMenu,
    menuList,
    viewButtonsList,
    boundaryInfo,
    openFromBoundary,
    viewList,
    updateCategory,
    addAddressModal,
  } = useTheMap(props);

  return (
    <MainFrame refId={theMapBox} width={props.width}>
      <div
        ref={mapElement}
        className="map-container mapBox"
        style={{
          position: "absolute",
          width: dim.main[0] + "%",
          height: dim.main[1] + "%",
          left: 0,
          top: 0,
        }}
      >
        {buttonsList
          .filter((e) => e.active)
          .map(({ Container, active, ...rest }, index) => (
            <Container key={index} {...rest} />
          ))}

        <MenuBar
          menuList={menuList}
          viewButtonsList={viewButtonsList}
          boundaryInfo={boundaryInfo}
          viewList={viewList}
        />
        <PositionScreen
          board={board}
          beginRaster={beginRaster}
          continueRaster={continueRaster}
          finishRaster={finishRaster}
          pinAnimStep={pinAnimStep}
          startPinAnim={startPinAnim}
          confirmPosition={confirmPosition}
          pinAnim={pinAnim}
          resetPosition={resetPosition}
        />
        <NextTerritory
          boundaryInfo={boundaryInfo}
          openFromBoundary={openFromBoundary}
          terId={terId}
        />
      </div>
      <Title terId={terId} title={title} sectionId={sectionId} />
      <InfoBox
        leyendRef={leyendRef}
        dim={dim}
        openBox2={openBox2}
        address={address}
        getFeat={getFeat}
        points_layer={points_layer}
        handleClickAddr={handleClickAddr}
        focusPoint={focusPoint}
        updateCheck={updateCheck}
        closeGPS={closeGPS}
        goTo={goTo}
        focusLayer={focusLayer}
        openWindow={openWindow}
        buttonsMenu={buttonsMenu}
        scrollMenu={scrollMenu}
      />
      <GenericModal
        open={open.status}
        data={msgType[open.status]}
        close={closeMsg}
      >
        {open.status === "newEvent" && (
          <EventsList
            data={open}
            updateCategory={updateCategory}
            addAddressModal={addAddressModal}
          />
        )}
      </GenericModal>
      <GenericModal
        open={open2.status}
        data={msgType[open2.status]}
        close={closeMsg2}
      />
    </MainFrame>
  );
}
